import type {IDirective} from 'angular';

/**
 * @ngdoc directive
 * @name kpHref
 * @module portaro.directives
 *
 * @restrict A
 * @element A
 *
 * @param {string} kpHref URI without context path
 *
 * @requires constant:CONTEXT_PATH
 *
 * @description
 * Directive prepends `CONTEXT_PATH` before URI specified in `kpHref` attribute
 *
 * @example
 * ```html
 * <example name="kpHrefExample" module="kpHrefExample">
 *      <file name="index.html">
 *          <a class="link" kp-href="/favourites">Favourites</a>
 *          <hr>
 *           <label>URL: <input type="text" ng-model="href"></label>
 *           <a href="link" kp-href="{{href}}">{{href}}</a>
 *      </file>
 *      <file name="script.js">
 *          angular.module('kpHrefExample', ['portaro.directives'])
 *              .constant('CONTEXT_PATH', 'context');
 *      </file>
 * </example>
 * ```
 */
export default class HrefDirective implements IDirective {
    public static directiveName = 'kpHref';

    public restrict = 'A';

    /*@ngInject*/
    constructor(private CONTEXT_PATH: string) {
    }

    public link($scope, $element, $attrs) {
        $attrs.$observe(HrefDirective.directiveName, () => {
            $attrs.$set('href', `${this.CONTEXT_PATH}${$attrs[HrefDirective.directiveName]}`);
        });
    }
}
